import { defineMessages } from 'react-intl';

export const feedbackMessages = defineMessages({
  COMMENT_LABEL: {
    defaultMessage: 'Veuillez nous en dire plus',
  },
  COMMENT_PLACEHOLDER: {
    defaultMessage: 'Votre avis compte pour nous',
  },
  SUBMIT_SUCCESS: {
    defaultMessage: 'Merci pour votre commentaire, il a été envoyé avec succès.',
  },
  DELETE_SUCCESS: {
    defaultMessage: 'Votre signalement a bien été supprimé.',
  },
});
